import { makeAutoObservable } from 'mobx'

/** Favorites entity */
export interface IFavorites {
    id: number
    uuid: string

    user?: unknown
    createdBy?: unknown
    updatedBy?: unknown

    type: string
    title: string
    message: string

    entityCode?: string
    entityUuid?: string

    [key: string]: unknown
}

interface Pagination {
    page?: number
    limit?: number
    total?: number
}

/**
 * Domain singleton for the user's Favorites list.
 * Holds drawer UI state, pagination and loaded items.
 */
class FavoritesManager {
    // ---------- UI ----------
    isDrawerOpen = false
    isFilterOpen = false
    isFavoritesLoading = false
    isLoadingFirstPage = false
    isRemoveFromFavoritesLoading = false

    // ---------- DATA ----------
    favorites: IFavorites[] = []

    page = 1
    limit = 30
    total = 0

    constructor() {
        makeAutoObservable(this)
    }

    get hasMore(): boolean {
        return this.favorites.length < this.total
    }

    // ---------- UI setters ----------
    setIsLoadingFirstPage(v: boolean): void {
        this.isLoadingFirstPage = v
    }

    setIsDrawerOpen(v: boolean): void {
        this.isDrawerOpen = v
    }

    setIsFilterOpen(v: boolean): void {
        this.isFilterOpen = v
    }

    setIsFavoritesLoading(v: boolean): void {
        this.isFavoritesLoading = v
    }

    // ---------- DATA setters ----------
    setFavorites(items: IFavorites[]): void {
        if (Array.isArray(items)) {
            this.favorites = items
        }
    }

    appendFavorites(items: IFavorites[]): void {
        if (Array.isArray(items)) {
            this.favorites = [...this.favorites, ...items]
        }
    }

    setPagination({ page, limit, total }: Pagination): void {
        if (page !== undefined) this.page = page
        if (limit !== undefined) this.limit = limit
        if (total !== undefined) this.total = total
    }

    setIsRemoveFromFavoritesLoading(v: boolean): void {
        this.isRemoveFromFavoritesLoading = v
    }

    removeFavoriteByUuid(uuid: string): void {
        this.favorites = this.favorites.filter((item) => item.uuid !== uuid)
    }
}

export const favoritesManager = new FavoritesManager()
